<!-- 模块管理 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea ModuleManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 后台权限内容 -->
        <div class="content">
          <el-tabs
            v-model="activeIndex"
            @tab-click="handleClick">
            <el-tab-pane
              :label="item.name"
              :name="index.toString()"
              v-for="(item, index) in modulesList"
              :key="index">
              <!-- 添加按钮 -->
              <div class="addButton">
                <el-button type="primary" @click="operateDialog('add')">添加</el-button>
              </div>

              <!-- 一级模板列表 开始 -->
              <el-table
                v-loading="loading"
                :data="item.list"
                style="width: 100%">
                
                <!-- row-key="function_id"
                :tree-props="{children: 'children'}" -->

                <!-- 二级模板列表 开始 -->
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table
                      class="tList"
                      :data="props.row.sunList"
                      :show-header= false
                      style="">
                      <el-table-column
                        label="排序">
                        <template slot-scope="scope">
                          <el-button type="text" @click="operateDialog('changeIndex',scope.row)">{{ scope.row.index }}</el-button>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="模块"
                        prop="function_name">
                      </el-table-column>
                      <el-table-column
                        label="URL"
                        prop="function_soft">
                      </el-table-column>
                      <el-table-column
                        label="状态">
                        <template slot-scope="scope">
                          <el-button type="text" @click="operateDialog('changeStatus',scope.row)">{{ scope.row.function_show ? '启用' : '禁用'}}</el-button>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="操作">
                        <template slot-scope="scope">
                          <el-button type="text" @click="operateDialog('alter', scope.row)">修改</el-button>
                          <el-button type="text" @click="operateDialog('delete', scope.row)">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <!-- 二级模板列表 结束 -->
                <el-table-column
                  label="排序">
                  <template slot-scope="scope">
                    <el-button type="text" @click="operateDialog('changeIndex',scope.row)">{{ scope.row.index }}</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  label="模块"
                  prop="function_name">
                </el-table-column>
                <el-table-column
                  label="URL"
                  prop="function_soft">
                </el-table-column>
                <el-table-column
                  label="状态">
                  <template slot-scope="scope">
                    <el-button type="text" @click="operateDialog('changeStatus',scope.row)">{{ scope.row.function_show ? '启用' : '禁用'}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="operateDialog('alter', scope.row)">修改</el-button>
                    <el-button type="text" @click="operateDialog('delete', scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 一级模板列表 结束 -->

            </el-tab-pane>
          </el-tabs>

        </div>

        <!-- 对话框 -->
        <el-dialog
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">

          <!-- 修改排序 -->
          <div
            class="changeIndexWrapper"
            v-if="dialogData.type === 'changeIndex'">
            <el-input class="input" v-model="dialogData.info.index"></el-input>
            <div slot="footer" class="dialog-footer">
              <el-button @click="changeModuleOrder()">确 认</el-button>
            </div>
          </div>

          <!-- 状态 -->
          <div
            class="changeStatusWrapper"
            v-else-if="dialogData.type === 'changeStatus'">
            <p class="text">
              当前用户状态为
              <span class="bold">
              {{ dialogData.info.function_show ? '启用' : '禁用'}}
              </span>
            </p>
            <p class="text">
              是否将状态改为
              <span class="bold">
              {{ !dialogData.info.function_show ? '启用' : '禁用'}}？
              </span>
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="changeModuleStatus()">{{ !dialogData.info.function_show ? '启用' : '禁用'}}</el-button>
            </div>
          </div>

          <!-- 删除 -->
          <div
            class="changeStatusWrapper"
            v-else-if="dialogData.type === 'delete'">
            <p class="text">
              是否删除该模板？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="deleteModule()">删除</el-button>
            </div>
          </div>

          <!-- 添加或修改模板信息 -->
          <div v-else>
            <el-form
              label-width="100px"
              :model="dialogData.info">
              <el-form-item label="模块名称:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.function_name"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="前端Tab:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.function_tab"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="URL:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.function_soft"></el-input>
                </div>
              </el-form-item>

              <el-form-item label="使用iframe:">
                <el-switch
                  v-model="dialogData.info.function_is_frame"
                  active-value="1"
                  inactive-value="0">
                </el-switch>
              </el-form-item>

              <el-form-item label="上级菜单:">
                <div class="inputBox">
                  <el-select
                    v-model="dialogData.info.parent_function_id">
                    <el-option
                      label="无"
                      value=""
                      selected>
                    </el-option>
                    <el-option
                      v-for="item in dialogData.parentList"
                      :key="item.function_id"
                      :label="item.function_name"
                      :value="item.function_id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateModule()">确 认</el-button>
            </div>
          </div>

          

        </el-dialog>
      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import {
    showToast,
    deepCopy
  } from "../../../../static/js/utility/utility.js"
  import { systemApi } from "../../../../static/js/api.js"

  export default {
    name: 'ModuleManage',
    components: {
      BreadCrumb
    },
    data() {
      return {
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 当前选中tab
        activeIndex: '0',
        // 总模板列表数据
        modulesList: [],
        loading: '',
        // 上级菜单列表
        parentList: []
      }
    },
    mounted(){
      this.getModuleList()
    },
    created: async function () {
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      // 删除模板
      deleteModule: async function () {
        let vm = this
        let data = {
          function_id: vm.dialogData.info.function_id
        }
        let res = await systemApi.deleteModule(data)
        if (res.meta.code === 200) {
          showToast('删除成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getModuleList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 排序
      changeModuleOrder: async function () {
        let vm = this
        let data = {
          function_id: vm.dialogData.info.function_id,
          order: vm.dialogData.info.index
        }
        let res = await systemApi.changeModuleOrder(data)
        if (res.meta.code === 200) {
          vm.dialogData.visible = !(vm.dialogData.visible)
          showToast('已重新排序')
          vm.getModuleList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 修改模板状态
      changeModuleStatus: async function () {
        let vm = this
        let data = {
          function_id: vm.dialogData.info.function_id
        }
        let res = await systemApi.changeModuleStatus(data)
        if (res.meta.code === 200) {
          vm.dialogData.visible = !(vm.dialogData.visible)
          showToast('修改成功')
          vm.getModuleList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 确认更新（新增/修改）模块
      updateModule: async function () {
        let vm = this
        // 判断类型
        let type = this.modulesList[this.activeIndex].type === 'platform_access' ? 'P' : 'C'
        let data = {
          function_id: vm.dialogData.type === 'add' ? '' : vm.dialogData.info.function_id ,
          name: vm.dialogData.info.function_name,
          // type: vm.dialogData.info.function_type ? vm.dialogData.info.function_type : type ,
          type: type,
          url: vm.dialogData.info.function_soft,
          tab: vm.dialogData.info.function_tab,
          parent_id: vm.dialogData.info.parent_function_id,
          is_frame: vm.dialogData.info.function_is_frame,

        }
        // 判断值
        if (data.name === '') {
          showToast('模板名称不能为空！')
          return false
        }
        if (data.tab === '') {
          showToast('前端Tab不能为空！')
          return false
        }

        let res = await systemApi.updateModule(data)
        if (res.meta.code === 200) {
          vm.dialogData.visible = !(vm.dialogData.visible)
          showToast(data.function_id === '' ? '添加成功' : '修改成功')
          vm.getModuleList()
        } else {
          showToast(res.meta.message)
        }
        console.log('res', res)
      },
      // 操作对话框
      operateDialog: function (type, info) {
        // console.log('tag', this.modulesList[this.activeIndex])
        console.log(type, info)
        // 获取上级菜单列表
        // this.parentList = this.modulesList[this.activeIndex].list
        let parentList = this.modulesList[this.activeIndex].list
        let infoNull = {
            function_name: '' ,
            function_soft: '',
            function_type: ''
          }
        this.dialogData = {
          type: type,
          title: type === 'changeStatus' ? '' : type === 'add' ? '添加模块' : type === 'alter' ? '修改模板信息' : '排序',
          visible: !(this.dialogData.visible),
          info: info ? deepCopy(info) : infoNull,
          parentList: this.modulesList[this.activeIndex].list
        }
        // console.log('this', this.dialogData)
      },
      // 数据处理
      proccessData: function (data) {
        let modulesList = data
        for (let i in modulesList) {
          modulesList[i].name = modulesList[i].type === 'platform_access' ? '平台后台权限' : '企业后台权限'
          // 计算序号
          let list = modulesList[i].list
          for (let j in list) {
            list[j].index = Number(j) + 1
            list[j].sunList = list[j].children
            delete list[j].children
            for (let z in list[j].sunList) {
              list[j].sunList[z].index = Number(z) + 1
            }
          }
          modulesList[i].list = list
        }
        // this.activeIndex = '0'
        this.modulesList = modulesList
      },
      // 获取模块列表
      getModuleList: async function () {
        let vm = this

        vm.loading = true
        let res = await systemApi.getModuleList()
        vm.loading = false
        if (res.meta.code === 200) {
          console.log('模块列表', res.data)
          vm.proccessData(res.data)
        } else {
          showToast(res.meta.message)
        }
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss" scoped>
.ModuleManage {
  .changeIndexWrapper {
    .input{
      width: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/System/ModuleManage.vue